import IconWrapper from './IconWrapper';

const LocationIcon = (props) => {
  return (
    <IconWrapper {...props}>
      <svg enableBackground="new 0 0 64 64" version="1.1" viewBox="0 0 64 64" xmlSpace="preserve">
        <g id="Glyph">
          <path d="M52.708,20.849C52.708,8.185,44.584,0,32,0S11.292,8.185,11.292,20.849c0,10.556,16.311,31.747,18.175,34.118l2.278,2.928   c-9.542,0.025-17.237,1.38-17.237,3.051c0,1.686,7.836,3.053,17.502,3.053s17.502-1.367,17.502-3.053   c0-1.672-7.704-3.028-17.255-3.051l2.292-2.928C36.396,52.581,52.708,31.39,52.708,20.849z M25.294,20.835   c0-3.604,3.002-6.526,6.706-6.526c3.704,0,6.706,2.922,6.706,6.526S35.704,27.361,32,27.361   C28.296,27.361,25.294,24.439,25.294,20.835z" />
        </g>
      </svg>
    </IconWrapper>
  );
};

export default LocationIcon;
